var dataLayer = (typeof(dataLayer) !== "undefined" && dataLayer instanceof Array) ? dataLayer : [];
var videoId= '';
var _playerTitle = {}, _playerAuthor = {}, _playerAuthorURL = {}, _playerUploadDate = {};
document.addEventListener('DOMContentLoaded', function() {
    observeVideoOverlay();
});

function observeVideoOverlay() {
    var targetNode = document.querySelector('.video-overlay iframe');
    if (!targetNode) {
        console.log('.video-overlay element not found');
        return;
    }
    var config = { attributes: true, childList: true, subtree: true };
    var callback = function(mutationList, observer) {
        for (var i = 0; i < mutationList.length; i++) {
            var mutation = mutationList[i];
            if (mutation.type === "attributes" && mutation.attributeName == "src") {

                if(mutation.target.src != window.location.origin+"/" && mutation.target.src.includes('player.vimeo')){
                    videoId = mutation.target.src;
                    window.addEventListener('message', onMessageReceived, false);

                } else{
                    videoId = '';
                    window.removeEventListener('message', onMessageReceived, false);
                }


            }
        }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}
function onMessageReceived(e) {
    if(typeof(e.data) == 'string'){
        console.log(typeof(e.data))
        console.log('here',e.data)
        var data = JSON.parse(e.data);
        switch (data.event) {
            case 'ready':
                onReady(data);
                break;
            case 'play':
                onPlay(data);
                break;
            case 'pause':
                onPause(data);
                break;
            case 'timeupdate':
                onPlayProgress(data);
                break;
        }
    }
}

function onReady(data) {
    getVimeoInfo("https://www.vimeo.com/api/oembed.json?url=https://vimeo.com/" + getLabel(videoId) + "&callback=vimeoCallback", vimeoCallback);
    post('addEventListener', 'play');
    post('addEventListener', 'pause');
    post('addEventListener', 'finish');
    post('addEventListener', 'playProgress');
}

function getVimeoInfo(url, callback) {
 
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    
    document.getElementsByTagName('body')[0].appendChild(script);
}

function onPlay(data) {
    console.log('play')
    dataLayer.push({
        event: "video",
        video_action: "play",
        video_url: 'https://vimeo.com/' + getLabel(videoId),
        video_percent: data.data.percent.toFixed(2) * 100,
        video_title: _playerTitle[getLabel(videoId)].toLowerCase()
    });
}
function onPause(data) {
    dataLayer.push({
        event: "video",
        video_action: "pause",
        video_url: 'https://vimeo.com/' + getLabel(videoId),
        video_percent: data.data.percent.toFixed(2) * 100,
        video_title: _playerTitle[getLabel(videoId)].toLowerCase()
    });
}
function onPlayProgress(data) {
    var percent = (Math.floor(data.data.seconds / data.data.duration * 4) / 4).toFixed(2);
    dataLayer.push({
        event: "video",
        video_action: "progress",
        video_url: 'https://vimeo.com/' + getLabel(videoId),
        video_percent: percent * 100,
        video_title: _playerTitle[getLabel(videoId)].toLowerCase()
    });
}
function getLabel(id) {
    return id.split('?')[0].split('/').pop();
}
// Callback function for the Vimeo API
function vimeoCallback(data) {
    _playerTitle[data['video_id']] = data['title'];
    _playerAuthor[data['video_id']] = data['author_name'];
    _playerAuthorURL[data['video_id']] = data['author_url'];
    _playerUploadDate[data['video_id']] = data['upload_date'];
}
// Post messages to the Vimeo player
function post(action, value) {
    var data = { method: action };
    if (value) {
        data.value = value;
    }
    var message = JSON.stringify(data);
    var players = document.querySelectorAll(".video-overlay iframe");
    Array.prototype.forEach.call(players, function(player) {
        var url = player.getAttribute("src");
        if (/player\.vimeo\.com\/video/.test(url)) {
            var prot = url.split('?')[0].split('//')[0];
            if (!prot) {
                url = "https:" + url.split('?')[0];
            }
            player.contentWindow.postMessage(message, url);
        }
    });
}
